// extracted by mini-css-extract-plugin
module.exports = {"DimensionsFeature":"wb_a bhj_b bhj_ux"};